<template>
    <div :class="{
        'cpt-suspension-page-border': isBorder, 'cpt-suspension-page': true,
        'cpt-suspension-top': isTop, 'cpt-suspension-bottom': isBottom,
        'cpt-suspension-left': isLeft, 'cpt-suspension-right': isRight
    }" ref="suspensionDiv" :key="designCache && designCache.id + current.id" :style="{
        position: position,
        width: setWidth,
        width: current.cptWidth + 'px',
        height: current.cptHeight + 'px',
        ...setPositionXY,
        ...setStyles,
        ...setTransform,
        ...setPostion,
    }">
        <div v-for="(item, index) in suspenComponents" :id="`div${item.id}`" 
            :key="designCache && designCache.id + item.id" v-show="item.cptShow" style="position: fixed;" :style="{
                width: item.cptWidth + 'px',
                height: item.cptHeight + 'px',
                top: item.cptY + 'px',
                left: item.cptX + 'px',
                zIndex: (item.cptOptionKey == 'cpt-dataV-border-option' && item.cptType != 'ngcombination-border') ? item.cptOption.attribute.zIndex : (components.length - index)
            }">
            <component :ref="(el) => setRefsNode(item.id, el)" :is="item.cptKey" :current="item" :refMap="refMap"
                :width="item.cptWidth" :scale="scale.containerScaleX" :components="components" :key="item.keyId"
                :height="item.cptHeight" :option="item.cptOption" @clickHandler="cptClickHandler" />
        </div>


    </div>
</template>

<script setup>
import { onMounted, ref, defineEmits, computed } from 'vue'
const emit = defineEmits(['clickHandler'])
const props = defineProps({
    width: Number,
    height: Number,
    scale: Number,
    option: Object,
    current: Object,
    refMap: Object,
    components: Object,
    designCache: Object,
})

// 是否开启边框
const isBorder = ref(true)
const designPage = location.href.includes('/design')

const position = computed(() => {
    return designPage ? 'absolute' : 'fixed'
})
const isTop = computed(() => {
    let position = props.option.attribute.position
    return position == 'top'
})

const isBottom = computed(() => {
    let bottom = props.option.attribute.position == 'bottom'

    return bottom
})
const isLeft = computed(() => {
    let left = props.option.attribute.position == 'left'
    return left
})
const isRight = computed(() => {
    let right = props.option.attribute.position == 'right'

    return right
})
const setPositionXY = computed(() => {
    return {
        'top': designPage ? '0px' : props.current.cptY + 'px',
        'left': designPage ? '0px' : props.current.cptX + 'px',
    }
})
const setPostion = computed(() => {
    // if(isLeft)
    console.log(isLeft, isRight, 'sadsd');
    let pX;
    let pY;
    if (isLeft.value || isRight.value) {
        pX = props.option.attribute.postitionX
    } else {
        pX = props.current.cptX
    }
    if (isTop.value || isBottom.value) {
        pY = props.option.attribute.postitionY
    } else {
        pY = props.current.cptY
    }

    if (designPage) {
        pY = -4
        pX = 0
    }
    console.log(pY, pX, props.option.attribute.postitionX, 'asdiojasjdiasdjiij');
    return {
        '---postsionX': pX + 'px',
        '---postsionY': pY + 'px',
    }
})
const setStyles = computed(() => {
    const borderColor = props.option.attribute.borderColor ? props.option.attribute.borderColor : 'rgb(110, 110, 110)'
    const borderSize = `${props.option.attribute.borderSize || 0}px`;
    const borderRadius = props.option.attribute.borderRadius ? `${props.option.attribute.borderRadius}px` : '0px'

    isBorder.value = designPage
    console.log(props.option.attribute, 'attribute')
    return {
        '---backgroundColor': props.option.attribute.backgroundColor,
        '---borderColor': borderColor,
        '---borderSize': borderSize,
        '---borderRadius': borderRadius,
        'z-Index': props.component ? props.component.length + 1 : 100,
    }
})
const setTransform = computed(() => {

    if (designPage) {
        return {}
    }
    let containerScaleX = props.scale?.containerScaleX
    let containerScaleY = props.scale?.containerScaleY
    let transform = {
        transform: props.designCache?.scaleType === 1 ? `scaleX(${containerScaleX}) scaleY(${containerScaleY})` : `scale(${containerScaleX})`
    }
    return transform
})

const suspensionDiv = ref(null)
const suspenComponents = ref([])


// const setSuspension = () => {
//     let isGroups = props.current?.group
//     if (!isGroups) {
//         return
//     }
//     // 获取当前悬浮框并且排除自己
//     let groups = isGroups.filter(x => x !== props.current.id)
//     for (let i = 0; i < groups.length; i++) {
//         const element = document.querySelector(`#div${groups[i]}`);
//         element && element.remove()
//     }
//     let componentCopy = JSON.parse(JSON.stringify(props.components))
//     // 生成子组件
//     suspenComponents.value = componentCopy.filter(item => {
//         // 判断是否是悬浮框
//         let isSuspension = item?.cptType !== "cpt-suspension"
//         // 匹配悬浮框组的id
//         let isChildComps = isGroups.includes(item.id) && isSuspension
//         if (isChildComps) {
//             item.cptY = item.cptY - props.current.cptY
//         }
//         return isChildComps
//     })
// }
const setSuspension = () => {
    const isGroups = props.current?.group || [];
    // 确保isGroups是数组，避免后续处理出现问题
    if (!Array.isArray(isGroups)) {
        return;
    }
    // 使用document.querySelectorAll并一次性处理所有需要删除的元素
    // const elementsToRemove = [];
    // isGroups.forEach((groupId) => {
    //     const element = document.querySelector(`#div${groupId}`);
    //     if (element) {
    //         elementsToRemove.push(element);
    //     }
    // });
    // elementsToRemove.forEach((element) => element.remove());

    let componentCopy;
    try {
        // 尝试对props.components进行深拷贝，考虑性能和异常处理
        componentCopy = JSON.parse(JSON.stringify(props.components || []));
    } catch (error) {
        console.error("Error deep copying components:", error);
        return; // 处理失败时返回
    }

    // 生成子组件，优化逻辑判断和注释，提高可读性
    suspenComponents.value = componentCopy.filter(item => {
        // 判断是否是悬浮框并排除自己
        const isNotSuspension = item?.cptType === "cpt-suspension";
        const isChildComp = isGroups.includes(item.id) && !isNotSuspension;
        if (isChildComp) {
            item.cptY = item.cptY - (props.current?.cptY || 0);
            item.cptX = item.cptX - (props.current?.cptX || 0)
        }
        return isChildComp;
    });
}

const cptClickHandler = (...args) => emit('clickHandler', ...args)

const setRefsNode = (refName, el) => {
    props.refMap[refName] = el
}

// 组件挂载后添加滚动事件监听器
onMounted(() => {
    // console.log(_.debounce)
    // const reference = props.refMap.previewPage
    // const reference = props.refMap.previewPage
    // const reference = document.getElementById('#scaleDiv')
    // 当前是否是预览
    if (!designPage) {

        setSuspension()
    }

});


</script>

<style scoped>
.cpt-suspension-page {
    width: 100%;
    height: 100%;
    border: var(---borderSize) solid var(---borderColor);
    background: var(---backgroundColor);
    border-radius: var(---borderRadius);
    transform-origin: 0 0;
}

.cpt-suspension-page-border {
    border: 2px dashed rgb(110, 110, 110);
}

.cpt-suspension-top {
    top: var(---postsionY) !important;
    left: var(---postsionX) !important;
    bottom: unset !important;
}

.cpt-suspension-bottom {
    bottom: var(---postsionY) !important;
    left: var(---postsionX) !important;
    top: unset !important;
}

.cpt-suspension-left {
    top: var(---postsionY) !important;
    left: var(---postsionX) !important;
    right: unset !important;
}

.cpt-suspension-right {
    bottom: var(---postsionY) !important;
    right: var(---postsionX) !important;
    left: unset !important;
}
</style>
